var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDutch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 142 92.6",
    style: {
      enableBackground: "new 0 0 142 92.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0-dutch{fill:#E71E26;}\n\t.st1-dutch{fill:#FFFFFF;}\n\t.st2-dutch{fill:#084CA1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Map"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    className: "st0-dutch",
    width: 140.7,
    height: 92.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.7,
    y: 30.7,
    className: "st1-dutch",
    width: 141.1,
    height: 61.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 61.7,
    className: "st2-dutch",
    width: 141.5,
    height: 30.9
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDutch);
export default __webpack_public_path__ + "static/media/dutch.d839f91ef0343e48aa020be2a118ddf9.svg";
export { ForwardRef as ReactComponent };